import * as types from '../types.js';

export default {

	html: `
		<style>
			#create-outputs #company_id		{ width: 100%; }
			#create-outputs #warehouse_id	{ width: 100%; }
		</style>
		<form id="create-outputs" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<div class="title">
				Selecione o armazém de origem (opcional)
			</div>
			<p class="hint" style="margin:0.35rem 0 0.75rem;font-size:0.85rem;line-height:1.35;color:#444;">
				Sem armazém, o sistema busca saldo em <strong>todos</strong> os armazéns da empresa (FEFO/motor de picking). A reserva gera <strong>uma saída por pedido</strong>; cada linha registra o armazém da célula. Com armazém selecionado, o cabeçalho da saída usa esse armazém; sem seleção, usa o da primeira linha alocada.
				<strong>Faturamento/NF-e:</strong> a nota é emitida a partir dessa saída consolidada; o sistema permite <strong>uma NF por pedido</strong> (salvo cancelamento/inutilização da numeração).
			</p>
			<div class="mtl fsb">
				<label title="Empresa">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Armazém">Armazém
					<input id="warehouse_id" type="text" list="warehouses" placeholder="Todos os armazéns da empresa">
				</label>
			</div>
			<div class="ckb">
				<label title="Incluir itens com validade vencida na busca?">
					<input id="include_expired" type="checkbox" class="dib">&nbsp;Incluir&nbsp;expirados
				</label>
				<label title="Reservar estoques ou apenas estimar percentuais de atendimento?">
					Reservar&nbsp;estoques&nbsp;<input id="reserve_flag" type="checkbox" class="dib">
				</label>
			</div>
			<div class="mtm">
				<button class='bn_Escape button'>Cancelar</button>
				<button class='bn_Enter button'>Gerar <span id="count"></span> saídas</button>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#create-outputs',
		init(formset)
		{
			formset.form.eraseValues();
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
		},
	},
	
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#warehouse_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('warehouses')] },
		{ properties: { selector: '#include_expired' }, types: [types.checkbox()] },
		{ properties: { selector: '#reserve_flag' }, types: [types.checkbox()] },
	]

};

